import { User } from './types';

export const getName = <UserType extends User | null>(user?: UserType) => {
	if (user?.firstName || user?.lastName) {
		return `${user.firstName || ''} ${user.lastName || ''}`.trim();
	}

	return user?.username || '';
};
